import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { list, listRightSlot, listRoot } from './list.vanilla.mjs';

const TabsList = forwardRef(
  ({
    children,
    css,
    className: classNameFromProps,
    rightSlot,
    style,
    ...props
  }, forwardedRef) => {
    return /* @__PURE__ */ jsxs(
      StyledTabsListRoot,
      {
        "data-scope": "tabs",
        "data-part": "list-root",
        css,
        className: classNames(listRoot, classNameFromProps),
        style,
        children: [
          /* @__PURE__ */ jsx(
            TabsPrimitive.List,
            {
              "data-scope": "tabs",
              "data-part": "list",
              className: list,
              ref: forwardedRef,
              ...props,
              children
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              "data-scope": "tabs",
              "data-part": "list-right-slot",
              className: listRightSlot,
              children: rightSlot
            }
          )
        ]
      }
    );
  }
);
const StyledTabsListRoot = styled("div");
TabsList.displayName = "Tabs.List";

export { TabsList };
//# sourceMappingURL=List.mjs.map
